import Roundable from "../../mixins/Roundable";
import Sizeable from "../../mixins/Sizeable";
import Colorable from "../../mixins/Colorable";

export default {

    mixins: [Roundable, Sizeable, Colorable],

    props: {

        // Renders the button without a background and border on normal state
        text: {
            type: Boolean,
            default: false
        },

        // Renders the button without a background but with a border on normal state
        outlined: {
            type: Boolean,
            default: false
        },

        // Renders the button in a square
        icon: {
            type: Boolean,
            default: false
        },

        // Renders the button in a square circle style
        fab: {
            type: Boolean,
            default: false
        },

        // Renders the button without a background on any state
        plain: {
            type: Boolean,
            default: false
        },

        shadow: {
            type: Boolean,
            default: null
        },

        disabled: {
            type: Boolean,
            default: false
        },

        rounded: {
            type: [String, Boolean],
            default: true
        },

        activeColor: {
            default: null
        },

        // Adds the button's native 'type' attribute
        type: {
            type: String,
            default: 'button',
            validator: function (value) {
                return ['button', 'submit', 'reset'].indexOf(value) !== -1
            }
        }
    },
};

